var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPointer(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M14.08,17.726c0-4.416,3.595-8.01,8.011-8.01c4.418,0,8.01,3.594,8.01,8.01 c0,5.084-6.096,12.012-8.01,14.059C20.178,29.737,14.08,22.815,14.08,17.726 M11.965,17.563c0,7.02,9.141,16.24,9.529,16.629 c0.165,0.164,0.382,0.246,0.597,0.246s0.433-0.082,0.599-0.246c0.388-0.389,9.528-9.609,9.528-16.629 c0-5.583-4.543-10.126-10.127-10.126C16.507,7.438,11.965,11.98,11.965,17.563"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 11.965,
    y: 7.438,
    clipPath: "url(#SVGID_2_)",
    fill: "#FFFFFF",
    width: 20.25,
    height: 27.001
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_3_",
    d: "M19.622,17.313c0-1.362,1.109-2.469,2.469-2.469c1.361,0,2.469,1.107,2.469,2.469 c0,1.362-1.107,2.469-2.469,2.469C20.731,19.782,19.622,18.675,19.622,17.313 M17.607,17.313c0,2.475,2.009,4.485,4.485,4.485 c2.475,0,4.482-2.01,4.482-4.485c0-2.476-2.008-4.483-4.482-4.483C19.616,12.829,17.607,14.836,17.607,17.313"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 17.607,
    y: 12.829,
    clipPath: "url(#SVGID_4_)",
    fill: "#FFFFFF",
    width: 8.968,
    height: 8.968
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointer);
export default __webpack_public_path__ + "static/media/pointer.78b56ec5da77bfa6a84270e05e3222bd.svg";
export { ForwardRef as ReactComponent };